module.exports = __webpack_public_path__ + "img/UT0370.71bf70cb.png";